<div class="appContentsContainer listPage">
  <form class="formGroup container halfForm">
    <div class="pageTitle">
      {{ "royalDecree.titleSpecficFields" | translate }}
    </div>
    <div class="lineGradient"></div>
  </form>
  <div
    [ngClass]="{
      box: titleReformSelected != '',
      width100: titleReformSelected == ''
    }"
  >
    <app-tree
      #tree
      *ngIf="reformsLoaded && certificatesLoaded"
      [treeData]="treeData"
      [options]="optionsTree"
      (itemSelected)="itemSelected($event)"
      (action)="action($event)"
    ></app-tree>
  </div>

  <div *ngIf="titleReformSelected" class="boxRigth">
    {{ titleReformSelected }}
    <table>
      <caption style="display: none">
        Texto prueba
      </caption>
      <thead>
        <th>
          <input
            class="alingCheckbox"
            type="checkbox"
            style="cursor: pointer !important"
            [checked]="allFieldsChecked"
            (click)="selectItem('all')"
          />
        </th>
        <th></th>
        <th></th>
        <th>Id</th>
        <th>Texto</th>
        <th>Tipo</th>
        <th>Obl.</th>
        <th>Vinculación</th>
      </thead>
      <tbody class="filterPageTableBody">
        <ng-container *ngFor="let field of fieldsLinkedList">
          <tr>
            <td>
              <input
                class="alingCheckbox"
                type="checkbox"
                style="cursor: pointer !important"
                [checked]="field.checked"
                (click)="selectItem(field)"
              />
            </td>
            <td>
              <button class="arrowUpDown" (click)="moveUp(field)" type="button">
                <em class="fas fa-arrow-up"></em>
              </button>
            </td>
            <td>
              <button
                class="arrowUpDown"
                (click)="moveDown(field)"
                type="button"
              >
                <em class="fas fa-arrow-down"></em>
              </button>
            </td>
            <td>{{ field.ccCampoid }}</td>
            <td>{{ field.cdTexto }}</td>
            <td>{{ field.cdTipo }}</td>
            <td>{{ field.ccObligatorio == 1 ? "OBL" : "OPC" }}</td>
            <td *ngIf="field.ccValorvinculacion && field.ccCampovinculado">
              {{ field.ccValorvinculacion }}({{ field.ccCampovinculado }})
            </td>
            <td
              *ngIf="!field.ccValorvinculacion || !field.ccCampovinculado"
            ></td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    <button (click)="removeCampoAsociado()">
      <em class="far fa-trash-alt"></em>
    </button>

    <form [formGroup]="addFieldForm" (ngSubmit)="onAddField()" class="formSize">
      <div class="formOptions">
        <div class="partOfForm">
          <p><strong>Campo asociado</strong></p>
          <select formControlName="field">
            <option [ngValue]="empty"></option>
            <option
              *ngFor="let field of fieldsAvailablesList"
              [ngValue]="field.cdId"
            >
              {{ field.cdId }} - {{ field.cdTexto }}
            </option>
          </select>
        </div>
        <div class="partOfForm2">
          <div class="centerRadio1">
            <p><strong>Obligatorio</strong></p>
            <label>Sí</label>
            <input
              class="mr-1"
              id="mandatory"
              type="radio"
              value="OBL"
              name="mandatory"
              style="cursor: pointer !important"
              [checked]="addFieldForm.value.mandatory == 'OBL'"
              (change)="changeMandatory($event)"
            />
            <label>No</label>
            <input
              id="mandatory"
              type="radio"
              value="OPC"
              name="mandatory"
              style="cursor: pointer !important"
              [checked]="addFieldForm.value.mandatory == 'OPC'"
              (change)="changeMandatory($event)"
            />
          </div>
        </div>
      </div>
      <div class="container-button">
        <button><em class="fas fa-plus-square"></em></button>
      </div>
    </form>

    <form
      [formGroup]="linkBooleanForm"
      (ngSubmit)="onLink()"
      *ngIf="listBoolean.length > 0"
      class="formSize"
    >
      <div class="formOptions">
        <div class="partOfForm3">
          <p><strong>Booleano</strong></p>
          <select formControlName="boolean">
            <option [ngValue]="empty"></option>
            <option
              *ngFor="let booleano of listBoolean"
              [ngValue]="booleano.cdId"
            >
              {{ booleano.cdId }} - {{ booleano.cdTexto }}
            </option>
          </select>
        </div>
        <div style="width: 19%; float: left; margin-right: 2%">
          <div class="centerRadio2">
            <p><strong>Condición</strong></p>
            <label>Sí</label>
            <input
              class="mr-1"
              id="mandatory"
              type="radio"
              value="S"
              name="mandatory"
              style="cursor: pointer !important"
              [checked]="linkBooleanForm.value.mandatory == 'S'"
              (change)="changeMandatoryBoolean($event)"
            />
            <label>No</label>
            <input
              id="mandatory"
              type="radio"
              value="N"
              name="mandatory"
              style="cursor: pointer !important"
              [checked]="linkBooleanForm.value.mandatory == 'N'"
              (change)="changeMandatoryBoolean($event)"
            />
          </div>
        </div>
        <div class="partOfForm3">
          <p><strong>Campo</strong></p>
          <select formControlName="fieldLinked">
            <option [ngValue]="empty"></option>
            <option
              *ngFor="let field of fieldsLinkedList"
              [ngValue]="field.ccUniqueid"
            >
              {{ field.ccCampoid }} - {{ field.cdTexto }}
            </option>
          </select>
        </div>
      </div>
      <div class="container-button">
        <button><em class="fas fa-file-medical"></em></button>
      </div>
    </form>

    <button (click)="goList()">
      <em class="fa-user-edit fas"></em>
    </button>
  </div>
  <div class="backButton">
    <button
      class="formButtonBack"
      type="button"
      (click)="goPredefinedMailBox()"
    >
      <em class="fas fa-times fa-2x backButtonAlign"></em>
    </button>
  </div>

  <app-modal-form
    #modal
    (sendForm)="sendForm($event)"
    [title]="titleModal"
    [confirmMessage]="
      '<strong>¿Estás seguro de que quieres modificarlo?</strong>'
    "
  ></app-modal-form>

  <swal
    #confirmSwal
    html="<strong>¿Estás seguro de borrarlo?</strong>"
    icon="warning"
    [showCancelButton]="true"
    [swalOptions]="{
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      allowEscapeKey: false,
      allowOutsideClick: false
    }"
    [focusCancel]="true"
  >
  </swal>
</div>
